<template>
  <div class="AppointmentList CommonContentSingle-gray">
    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);min-height: 80px;height: auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline"
          style="margin: 20px 0px;background: rgba(245, 247, 250, 1);padding: 10px;overflow: hidden;height: 42px;">
          <el-form-item label="学生姓名" style="width:20%;">
            <el-input placeholder="请输入姓名" v-model.trim="ruleForm.StudentName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('original.account')" style="width:20%;">
            <el-input :placeholder="'请输入' + $t('original.account')" v-model.trim="ruleForm.StudentAccount"></el-input>
          </el-form-item>
          <el-form-item label="当前状态" style="width:20%;">
            <el-form-item label="" prop="State">
              <el-select v-model="ruleForm.State" placeholder="请选择状态">
                <el-option label="未评估" value="0"></el-option>
                <el-option label="已评估" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-button type="primary" @click="resetForm()" style="margin-left: 10px;float: right;">重置
          </el-button>
          <el-button type="primary" @click="onSelect()" style="float: right;">查询</el-button>
        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1);">
        <el-table class="Page" :data="AppointList" style="width: 100%;" v-loading="IsLoading"
          element-loading-background="rgba(255,255,255,1)" element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading">
          <el-table-column label="序号" min-width="5%"> <template slot-scope="scope"> {{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%"></el-table-column>
          <el-table-column prop="StudentName" label="学生姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Specialty" label="专业" min-width="10%"></el-table-column>
          <el-table-column prop="DeptName" label="学院" min-width="20%"></el-table-column>
          <el-table-column prop="ConsultID" label="咨询师账号" min-width="10%"></el-table-column>
          <el-table-column prop="ConsulName" label="咨询师姓名" min-width="10%"></el-table-column>
          <el-table-column label="评估状态" min-width="8%">
            <template slot-scope="scope">
              <div style="color:red;" v-if="scope.row.State == 0">{{ scope.row.EvalState }}</div>
              <div style="color:blue;" v-else>{{ scope.row.EvalState }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="CreatedDate" label="分配时间" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="6%" align="center">
            <template slot-scope="scope">
              <span class="rp-table_btn" @click="StartEval(scope.row)">
                开始评估
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="AppointList.length > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage1" :page-size="pageSize" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      MenuID: '',
      dialogHeight: '500px',
      AppointList: [],
      regionType: '',
      regionTypes: [],
      riRate: [],
      riRateContent: [],
      from: {
        TeacherVal: '',
        StudentVal: ''
      },
      filterObj: [],
      wonedata: '',
      wonedata2: '',
      showViewDetails: false,
      currentPage1: 1,
      Counts: 1,
      pageSize: 10,
      pageIndex: 0,
      detailsdata: '',
      ruleForm: {
        StudentName: '',
        StudentAccount: '',
        State: ''
      },
      IsLoading: true,
      IsDialogLoading: false,
    };
  },
  created() {
    this.Init();
  },
  methods: {
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.Init(val);
    },
    Fillin(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.from.UserID = event.UserID;
      this.from.Counselor = event.Counselor;
      this.WPPdialogVisible = true;
    },
    wlooks(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.wonedata = event;
      this.WPPdialogVisible2 = true;
      var xcscs = {
        AppointmentID: event.AppointmentID,
      };
      this.$Http_Post('ConsultSubscribe/FxConsultAnswer', { from: xcscs }).then(
        (res) => {
          this.$message.closeAll();
          if (res.Code == 200 || res.Code == 0) {
            this.wonedata2 = res.Data;
          } else {
          }
        }
      );
    },
    ViewDetails(row) {
      this.showViewDetails = true;
      var csccvsd = {
        AppointmentID: row.AppointmentID,
      };
      this.$Http_Post('ConsultAppoint/GetappointmentDetails', {
        from: csccvsd,
      }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          this.detailsdata = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    resetForm() {
      this.ruleForm.StudentName = ''
      this.ruleForm.StudentAccount = ''
      this.ruleForm.State = ''
      this.pageIndex = 1
      this.Init()
    },
    onSelect() {
      if (
        this.ruleForm.StudentName == '' &&
        this.ruleForm.StudentAccount == '' &&
        this.ruleForm.State == ''
      ) {
        this.$message({
          message: '您未输入查询条件',
          type: 'warning',
        });
      } else {
        this.pageIndex = 0;
        this.currentPage1 = 1;
        let _this = this;
        if (!_this.filterObj.filterTag) {
          _this.filterObj.filterTag = [];
        }
        this.$Http_Post('ReportCriData/GetUserListByConsultID', {
          StudentName: _this.ruleForm.StudentName,
          StudentAccount: _this.ruleForm.StudentAccount,
          State: _this.ruleForm.State,
          pageIndex: _this.pageIndex,
          pageSize: 10,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.AppointList = res.Data;
            this.Counts = res.Counts;
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },
    Init() {
      let _this = this;
      this.$Http_Post('ReportCriData/GetUserListByConsultID', {
        StudentName: _this.ruleForm.StudentName,
        StudentAccount: _this.ruleForm.StudentAccount,
        State: _this.ruleForm.State,
        pageIndex: _this.pageIndex,
        pageSize: _this.pageSize,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.AppointList = res.Data;
          _this.IsLoading = false;
          this.Counts = Number(res.Counts);
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    onClearData() {
      this.riRateContent = []
      this.from.StudentVal = ''
    },
    PeopleSetting() {
      this.WPPdialogVisible3 = true
      this.riRateContent = []
      this.regionTypes = [];
    },
    StartEval(item) {
      this.$router.push({
        path: '/ReportData/RPDataReportMaster',
        query: {
          MenuID: this.MenuID,
          TRPUserID: item.SettingID,
          UserID: item.UserID,
        },
      })
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.dialogHeight =
        (document.documentElement.clientHeight * 0.65).toString() + 'px'
    })
  },
};
</script>
<style>
.AppointmentList .demo-form-inline {
  padding: 24px;
}

.el-drawer__header {
  font-size: 20px;
  margin-bottom: 1px;
}

.AppointmentList .el-dialog {
  background-color: rgba(239.99999999999997,
      239.99999999999997,
      239.99999999999997,
      1);
}

.AppointmentList .el-dialog__header {
  padding: 0px !important;
}

.AppointmentList .el-dialog__body {
  padding-top: 14px;
  background-color: #fff;
}

.AppointmentList .el-textarea__inner {
  width: 600px;
}

.AppointmentList .el-input {
  width: 200px;
}

.AppointmentList .el-radio {
  margin-left: 0px;
}

.AppointmentList .el-form--inline .el-form-item {
  border: 1px solid rgba(245, 247, 250, 1);
  width: calc(50 - 2px);
  margin-right: 0px;
}

.AppointmentList .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.AppointmentList .el-dialog__body .el-form--inline .el-form-item {
  width: calc(50% - 20px);
}

.AppointmentList .el-dialog__body .hiucs {
  width: 680px !important;
}

.hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .el-textarea__inner {
  margin-left: 0px !important;
}

.AppointmentList .qxs1 .el-input__inner {
  border: none;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-radius: 0px;
}

.AppointmentList .bagtit .el-form-item {
  border: none !important;
}

.AppointmentList .el-dialog__body .el-form-item__content span {
  margin-left: 5px;
}

.AppointmentList .block {
  float: right;
}

.el-drawer__body tbody td {
  border: none;
}

.AppointmentList .el-descriptions-item__label {
  color: rgba(40, 40, 40, 1);
  font-size: 16px;
}

.AppointmentList .el-descriptions-item__content {
  color: rgba(141, 141, 141, 1);
}

.AppointmentList .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}

#el-drawer__title {
  color: #000;
  font-weight: 700;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: -3px;
  width: 100%;
}

.AppointmentList .ClientConsulting_right_ul>li {
  background-color: #031924;
  float: left;
  margin-top: 10px;
  width: calc(100% / 7 - 10px);
}

.AppointmentList .ClientConsulting_right_ul>li ul {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_ul>li ul li {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  background-color: #0a3554;
  margin-left: 4px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  color: #6ebec2;
  position: relative;
}

.AppointmentList .ClientConsulting_right_ul>li ul li p {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
}

.AppointmentList .ClientConsulting_right_ul>li ul li i:hover span {
  display: block;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  position: absolute;
  top: 0px;
  left: 0px;
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li:hover p {
  display: block;
}

.AppointmentList .ClientConsulting_right_top {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_top li {
  background-color: rgb(10 53 84);
  width: calc(100% / 7 - 10px);
  float: left;
  height: 56px;
  margin-top: 20px;
  border: 1px solid #00e6ff;
  margin-left: -1px;
  color: #6ebec2;
  text-align: center;
}

.AppointmentList .ClientConsulting_right_top li p {
  height: 20px;
  margin-top: 6px;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: 0px;
}

.AppointmentList .el-table__column-filter-trigger i {
  color: #fff;
  font-size: 16px;
  margin-left: 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 12px;
  margin-bottom: 20px;
}

.el-radio__inner {
  border: 1px solid #55585e;
}

.AppointmentList .el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

/*WPF修改*/
.bg-purple-left {
  float: left;
  width: 30%;
  height: 100%;
  background-color: #ebf5ff;
  height: calc(100% - 50px);
}

.bg-purple-right {
  position: relative;
  float: right;
  width: 69%;
  height: calc(100% - 50px);
  background-color: #ebf5ff;
}

.buttons {
  width: calc(100% - 40px);
  text-align: center;
  position: absolute;
  bottom: 20px;
}

.bg-purple-option {
  width: 100%;
  height: 50px;
  margin-top: 5px;
  text-align: center;
}

.bg-purple-content {
  width: 100%;
  height: calc(100% - 60px);
}
</style>
